/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';

import {
  GoogleMap,
  LoadScript,
  Marker,
  useJsApiLoader,
} from '@react-google-maps/api';

import IconMarket from '../../../../../assets/images/MarkerImage.png';
import config from '../../../../../config';
import { InputSearch } from '../../../../../shared/components/Input';

function Map({
  onCardClicked,
  lockersInfo,
  searchZipCode,
  searchIconColor,
  fontFamily,
  fontColorSecondary,
  isLockersInfoLoading,
  currentLocation,
  mapContainerSize,
}) {
  const defatultCenter = {
    lat: -23.22047,
    lng: -44.677924,
  };
  const [zoomMap, setZoomMap] = React.useState(7);
  const [map, setMap] = React.useState(null);
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: config.mapsKey,
  });
  const [centerMap, setCenterMap] = React.useState(
    currentLocation || defatultCenter,
  );

  const onLoad = React.useCallback(function callback(googleMap) {
    const bounds = new window.google.maps.LatLngBounds(centerMap);
    googleMap.fitBounds(bounds);
    setTimeout(() => {
      if (
        centerMap.lat === defatultCenter.lat &&
        centerMap.lng === defatultCenter.lng
      ) {
        googleMap.setZoom(8);
      } else {
        googleMap.setZoom(11);
      }
    }, 1000);
    setMap(googleMap);
  }, []);

  const onUnmount = React.useCallback(function callback() {
    setMap(null);
  }, []);

  const handleSearchZipCode = async (value) => {
    const processedValue = value.trim().replace(/-/g, '');
    if (processedValue !== '') {
      await searchZipCode(processedValue);
    }
  };

  useEffect(() => {
    if (currentLocation) {
      setCenterMap({
        lat: currentLocation.lat,
        lng: currentLocation.lng,
      });
    }
  }, [currentLocation]);

  useEffect(() => {
    if (lockersInfo.length > 0) {
      const lockerMaisProximo = lockersInfo[0];
      setCenterMap({
        lat: lockerMaisProximo.lat,
        lng: lockerMaisProximo.lng,
      });
    }
  }, [lockersInfo]);

  useEffect(() => {
    if (map) {
      map.setZoom(13);
    }
  }, [centerMap]);

  return isLoaded ? (
    <>
      <InputSearch
        onClick={handleSearchZipCode}
        buttonColor={searchIconColor}
        fontFamily={fontFamily}
        isLoading={isLockersInfoLoading}
        iconColor={fontColorSecondary}
      />
      <GoogleMap
        mapContainerStyle={mapContainerSize}
        map={map}
        zoom={zoomMap}
        center={centerMap}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        {lockersInfo?.map((locker) => {
          if (locker.lat && locker.lng) {
            return (
              <Marker
                key={locker.boxCode}
                icon={IconMarket}
                position={{ lat: locker.lat, lng: locker.lng }}
                onClick={() => onCardClicked(locker)}
              />
            );
          }
        }) ?? []}
      </GoogleMap>
    </>
  ) : (
    <> </>
  );
}

export default Map;
